/* eslint-disable */
import React, { PropTypes } from 'react';
import './painel.css'

class PainelTotalManifestacoes extends React.Component {

    constructor(props, context) {
        super(props, context);
    }


    render() {
        console.log('disparos ', this.props.total)
      
        return (
                <div className="col-lg-4 col-md-4 col-xs-4 centerRow">
                    <div className="overviewCard">
                        <div className="overviewCard-icon overviewCard-icon--document">
                            <i className="fa fa-bullhorn fa-2x"></i>
                        </div>
                        <div className="overviewCard-description">
                            <h3 className="overviewCard-title text-light"><strong>{this.props.total}</strong></h3>
                            <p className="overviewCard-subtitle">Total de manifestações no ano</p>
                        </div>
                    </div>
                </div>
            
            );
    }
}


export default PainelTotalManifestacoes;


/** WEBPACK FOOTER **
 ** ./src/components/relatorios/painelDashboard/PainelTotalManifestacoes.js
 **/